import Button from 'components/Button'
import ButtonPrimary from 'components/ButtonPrimary'
import ContactUsLink from 'components/ContactUsLink'
import DropdownText from 'components/DropdownText'
import Icon from 'components/Icon'
import { ArrowDownIcon } from 'components/Icon/icons/arrow-down'
import PageTitle from 'components/Page/Page.Title.js'
import ProductQuantity from 'components/ProductQuantity'
import TextTitleCompressedHeavyUpperCase from 'components/TextTitleCompressedHeavyUpperCase'
import TextTitleCondensed from 'components/TextTitleCondensed'
import TextTitleLight from 'components/TextTitleLight'
import { View } from 'components/View'
import { getOptionsProductUtil } from 'models/daos/product/utils/get-options'
import {
  getContentSizeGuideProductUtil,
  getContentWithoutSizeGuideProductUtil
} from 'models/daos/product/utils'
import { COUNTRY_CURRENCY } from 'modules/country/constants/currency'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import {
  STYLES_MARGIN,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import { logUtil } from 'packages/src'
import ProductPosterSearch from 'pages/Product/PosterSearch'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedNumber } from 'react-intl'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'
import getPriceStringUtil from 'utils/string/get-price'
import { createSelector } from 'reselect'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { connect } from 'react-redux'

/**
 * The size guide dropdown text's title.
 * @type {string}
 */
const SIZE_GUIDE_TEXT = 'Size Guide'
/**
 * Text used when used for the 'Add To Cart' button.
 * @type {string}
 */
const ADD_TO_CART_TEXT = 'Add To Cart'
/**
 * Text used when the Product is out of stock.
 * @type {string}
 */
const OUT_OF_STOCK_TEXT = 'Out Of Stock'

class ProductDetails extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    discountPrice: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    currency: PropTypes.oneOf(Object.values(COUNTRY_CURRENCY)),
    selectedProductQuantityId: PropTypes.number,
    productQuantities: PropTypes.arrayOf(PropTypes.object).isRequired,
    isLoadingProductQuantities: PropTypes.bool.isRequired,
    onClickAddToCart: PropTypes.func.isRequired,
    onChangeProductQuantity: PropTypes.func.isRequired,
    instance: PropTypes.object.isRequired,
    onClickChangeCurrency: PropTypes.func.isRequired,
    selectedOption: PropTypes.string,
    onChangeSelectedOption: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.handleClickProductQuantity = this.handleClickProductQuantity.bind(this)
    this.handleChangeOption = this.handleChangeOption.bind(this)
    this.handleClickChangeCurrency = this.handleClickChangeCurrency.bind(this)
    this.handleClickAddToCart = this.handleClickAddToCart.bind(this)
    const { selectedOption } = this.props
    this.state = {
      selectedOption
    }
    logUtil('ProductDetails').debug('[start] props=', props)
  }

  componentDidUpdate (prevProps, prevState) {
    const { selectedOption } = this.props
    if (selectedOption !== prevState.selectedOption) {
      this.setState({
        selectedOption
      })
    }
  }

  handleClickAddToCart () {
    this.props.onClickAddToCart(this.state.selectedOption)
  }

  handleChangeOption (selectedOption) {
    this.setState({
      selectedOption
    })
    const { onChangeSelectedOption } = this.props
    if (onChangeSelectedOption) {
      onChangeSelectedOption(selectedOption)
    }
  }

  handleClickChangeCurrency () {
    this.props.onClickChangeCurrency()
  }

  handleClickProductQuantity (productQuantity) {
    if (productQuantity === this.props.selectedProductQuantityId) {
      return
    }
    this.props.onChangeProductQuantity(productQuantity)
  }

  getContentSizeGuide () {
    return getContentSizeGuideProductUtil(this.props.content)
  }

  renderAddToCart () {
    // If it's out of stock, noop
    if (!this.props.selectedProductQuantityId) {
      return
    }
    return (
      <View py>
        <ButtonPrimary
          onClick={this.handleClickAddToCart}
          style={{
            width: '100%'
          }}
        >
          {ADD_TO_CART_TEXT}
        </ButtonPrimary>
      </View>
    )
  }

  renderSelectedOption () {
    const { selectedOption } = this.state
    if (!selectedOption) {
      return
    }
    return (
      <TextTitleCondensed pb={1.5}>
        Option: {selectedOption}
      </TextTitleCondensed>
    )
  }

  renderDescription () {
    let { content } = this.props
    content = getContentWithoutSizeGuideProductUtil(content)
    if (!content) {
      return
    }
    const descriptionMarkdown = markdownToHtmlStringUtil(content)
    const props = {
      dangerouslySetInnerHTML: {
        __html: descriptionMarkdown
      }
    }
    return <div {...props} />
  }

  renderName () {
    return (
      <PageTitle>
        <TextTitleCompressedHeavyUpperCase>
          {this.props.name}
        </TextTitleCompressedHeavyUpperCase>
      </PageTitle>
    )
  }

  renderOutOfStock () {
    if (this.props.selectedProductQuantityId ||
      this.props.isLoadingProductQuantities) {
      return
    }
    return (
      <h3
        style={{
          margin: `${STYLES_MARGIN.SMALL} auto`
        }}
      >
        {OUT_OF_STOCK_TEXT}
      </h3>
    )
  }

  renderStandardPrice () {
    return (
      <FormattedNumber
        currency={this.props.currency}
        style='currency'
        value={getPriceStringUtil(this.props.price)}
      />
    )
  }

  renderDiscountPrice () {
    return (
      <View
        style={{
          flexDirection: View.DIRECTION.ROW,
          justifyContent: View.JUSTIFY.CENTER
        }}
      >
        <div style={{ paddingRight: STYLES_PADDING.MEDIUM }}>
          <s>{this.renderStandardPrice()}</s>
        </div>
        <FormattedNumber
          currency={this.props.currency}
          style='currency'
          value={getPriceStringUtil(this.props.discountPrice)}
        />
      </View>
    )
  }

  renderPrice () {
    return (
      <Button
        onClick={this.handleClickChangeCurrency}
        style={{
          marginTop: STYLES_MARGIN.SMALL
        }}
      >
        <View
          style={{
            flexDirection: View.DIRECTION.ROW,
            alignItems: View.ALIGN.CENTER,
            justifyContent: View.JUSTIFY.CENTER
          }}
        >
          <TextTitleLight
            style={{
              marginRight: STYLES_MARGIN.SMALL
            }}
          >
            {this.props.discountPrice
              ? this.renderDiscountPrice()
              : this.renderStandardPrice()}
          </TextTitleLight>
          <Icon
            icon={ArrowDownIcon}
            size={Icon.SIZE.SMALLER}
            style={{
              marginBottom: '-0.166em'
            }}
          />
        </View>
      </Button>
    )
  }

  renderProductQuantities () {
    // If the product has only one size, no-op
    if (this.props.productQuantities.length <= 1) {
      return
    }
    return (
      <View
        my={2}
        row
      >
        {this.props.productQuantities.map((productQuantity, index) => {
          const isLast = (
            index === this.props.productQuantities.length - 1
          )
          const paddingRight = isLast
            ? null
            : STYLES_PADDING.BIG
          return (
            <div
              key={index}
              style={{
                paddingRight
              }}
            >
              <ProductQuantity
                key={index}
                value={productQuantity}
                isSelected={getIdReduxUtil(productQuantity) ===
                  this.props.selectedProductQuantityId}
                onClick={this.handleClickProductQuantity}
              />
            </div>
          )
        })}
      </View>
    )
  }

  renderSearchOptions () {
    const options = getOptionsProductUtil(this.props.instance)
    if (!options.length) {
      return
    }
    return <ProductPosterSearch />
  }

  renderOtherOptionRequest () {
    const options = getOptionsProductUtil(this.props.instance)
    if (!options.length) {
      return
    }
    return (
      <p
        style={{
          marginTop: STYLES_MARGIN.MEDIUM
        }}
      >
        <span>Want another quote? </span>
        <ContactUsLink />
      </p>
    )
  }

  renderSizeGuide () {
    const sizeGuideContent = this.getContentSizeGuide()
    if (!sizeGuideContent) {
      return
    }
    const sizeGuideMarkdown = markdownToHtmlStringUtil(sizeGuideContent)
    return (
      <DropdownText title={SIZE_GUIDE_TEXT}>
        <div
          dangerouslySetInnerHTML={{ __html: sizeGuideMarkdown }}
          style={{
            paddingTop: STYLES_PADDING.MEDIUM
          }}
        />
      </DropdownText>
    )
  }

  render () {
    return (
      <View
        style={{
          flex: '1',
          width: '100%',
          overflow: 'hidden'
        }}
      >
        {this.renderName()}
        {this.renderPrice()}
        {this.renderProductQuantities()}
        {this.renderSelectedOption()}
        {/* {this.renderOptions()} */}
        {this.renderSearchOptions()}
        {this.renderOutOfStock()}
        {this.renderAddToCart()}
        {this.renderOtherOptionRequest()}
        {this.renderSizeGuide()}
        {this.renderDescription()}
      </View>
    )
  }
}

const select = () => createSelector(
  isSmallScreenViewportSelect,
  (isSmallScreen) => ({
    isSmallScreen
  })
)

export default connect(select)(ProductDetails)
